import { defineStore } from 'pinia';
import { ElNotification } from 'element-plus';
import { api } from '@/services/http.service';

interface AvailableCurrencyCodeListState {
  availableCurrencyCodeList: string[];
  availableCurrencyCodeListLoading: boolean;
}

export const useAvailableCurrencyCodeListStore = defineStore({
  id: 'AvailableCurrencyCodeListStore',
  state: (): AvailableCurrencyCodeListState => ({
    availableCurrencyCodeList: [],
    availableCurrencyCodeListLoading: false,
  }),
  actions: {
    setAvailableCurrencyCodeList(codeList: string[]): void {
      this.availableCurrencyCodeList = codeList;
    },
    async updateAvailableCurrencyCodeList(
      { code, whitelabelId }: { code: string; whitelabelId: string },
    ): Promise<void> {
      return await api.currency.updateAvailableCurrencyListRequest.perform({
        currencyList: this.availableCurrencyCodeList,
        code,
        whitelabelId,
      })
        .then(() => {
          ElNotification({
            title: 'Success',
            message: 'Currency list updated successfully',
            type: 'success',
          });
        });
    },
    setAvailableCurrencyCodeListLoading(isLoading: boolean): void {
      this.availableCurrencyCodeListLoading = isLoading;
    },
  },
});
